import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-schedule",
  "use": "icon-schedule-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-schedule\"><path d=\"M28,2h-4c0-1.104-0.896-2-2-2s-2,0.896-2,2h-8c0-1.104-0.896-2-2-2S8,0.896,8,2H4C2.9,2,2,2.9,2,4v26c0,1.1,0.9,2,2,2h24  c1.1,0,2-0.9,2-2V4C30,2.9,29.1,2,28,2z M8,6c0,1.104,0.896,2,2,2s2-0.896,2-2h8c0,1.104,0.896,2,2,2s2-0.896,2-2h2v4H6V6H8z M6,28  V14h20v14H6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol